<template lang="pug">
  .component-delete-conf
    button.button.small.warning.fa.fa-times(@click="deleteConf")
</template>

<script>
  export default {
    name: 'DeleteConf',
    methods: {
      deleteConf() {
        this.$confirm('Are you sure?', 'Do you want to delete this configuration?', () => {
          this.$emit('click')
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DeleteConf.vue?2d9f74c0